import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { checkArray } from '../../../../Components/helper';
import { AddIcon, DeleteIcon } from '../../../../bombiix-icon';
import { NewInput } from '../../../../Components/PIM/common/NewInput';
import { NewCheckbox } from '../../../../Components/PIM/common/NewCheckbox';

function LibraryFilter({
  selectedLibrary,
  handleDelete,
  handleCheckAll,
  isallChecked,
  handleLibrarySearchText,
  handleSearchSubmit,
  searchText,
  CustomAddEditAccess,
  CustomDeleteAccess,
}) {
  const { t } = useTranslation('common');
  return (
    <div className="search-filter care-library-filter">
      <div className="product-list-search w-300">
        <div className="form w-100">
          <NewInput
            type="text"
            value={searchText}
            onChange={(e) => handleLibrarySearchText(e.target.value)}
            onKeyDown={handleSearchSubmit}
            placeholder={t('CUSTOM_MODULES.GROUP.LIBRARY_FILTER.SELECT_CUSTOM_MODULE_GROUP')}
          />
        </div>
      </div>
      {CustomAddEditAccess && (
        <Link className="filter-btn filter-button_add text-decoration-none" to="/libraries/custom-module/group/add">
          <AddIcon size={24} />
        </Link>
      )}
      {CustomDeleteAccess && (
        <button
          type="button"
          title={t('CUSTOM_MODULES.GROUP.LIBRARY_FILTER.DELETE_LIBRARY')}
          onClick={() => handleDelete()}
          className="filter-btn filter-button_add"
          disabled={!checkArray(selectedLibrary)}
        >
          <DeleteIcon size={24} />
        </button>
      )}

      <div className="break" />
      <div className="selectall-checkbox">
        <NewCheckbox name="selectAll" id="selectAll" onChange={(e) => handleCheckAll(e)} checked={isallChecked} />
        <label htmlFor="selectAll" className="btn btn-white btn-back-lib mb-0">
          <span>
            {isallChecked ? 'Unselect' : 'Select'}
            {t('CUSTOM_MODULES.GROUP.LIBRARY_FILTER.ALL')}
          </span>
        </label>
      </div>
    </div>
  );
}
export default LibraryFilter;
